// extracted by mini-css-extract-plugin
module.exports = {"container":"FlexContainerWithTitle_container__2YTBf","title":"FlexContainerWithTitle_title__3q-PF","childrenContainer":"FlexContainerWithTitle_childrenContainer__W3B3z"};